import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Q1 from '../views/Q1.vue'
import Q2 from '../views/Q2.vue'
import Q3 from '../views/Q3.vue'
import Q4 from '../views/Q4.vue'
import Q5 from '../views/Q5.vue'
import Calc from '../views/Calc.vue'
import Result from '../views/Result.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: { title: 'モデルハウスレコメンド小牧会場 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/q1',
    name: 'Q1',
    component: Q1,
    meta: { title: 'モデルハウスレコメンド小牧会場 | Q1 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/q2',
    name: 'Q2',
    component: Q2,
    meta: { title: 'モデルハウスレコメンド小牧会場 | Q2 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/q3',
    name: 'Q3',
    component: Q3,
    meta: { title: 'モデルハウスレコメンド小牧会場 | Q3 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/q4',
    name: 'Q4',
    component: Q4,
    meta: { title: 'モデルハウスレコメンド小牧会場 | Q4 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/q5',
    name: 'Q5',
    component: Q5,
    meta: { title: 'モデルハウスレコメンド小牧会場 | Q5 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/calc',
    name: 'calc',
    component: Calc,
    meta: { title: 'モデルハウスレコメンド小牧会場 | 計算中 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '/result',
    name: 'Result',
    component: Result,
    meta: { title: 'モデルハウスレコメンド小牧会場 | 結果発表 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
  {
    path: '*',
    name: 'notFound',
    component: Index,
    meta: { title: 'モデルハウスレコメンド小牧会場 | 中京テレビハウジング', desc: 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！' }
  },
]



const router = new VueRouter({
  mode: 'history',
  // eslint-disable-next-line no-unused-vars
  scrollBehavior (to, from, savedPosition){
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes
})

export default router
